import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=50ce1e68&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=50ce1e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce1e68",
  null
  
)

export default component.exports